import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import NoImage from "../../assets/images/noimages.jpg";
import { Link, useParams } from "react-router-dom";
import { APIURL } from "../../redux/action/config";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Formik } from "formik";
import silverImg from "../../assets/images/silver.png";
import bronzeImg from "../../assets/images/bronze.png";
import goldImg from "../../assets/images/gold.png";

import {
  AddressDelete,
  cancelRecurring,
  updateCustomers,
  VehicleDelete,
} from "../../redux/action/customers";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import UpdateVehicle from "../../components/modals/UpdateVehicle";
import AddVehicle from "../../components/modals/AddVehicle";
import AddAddress from "../../components/modals/AddAddress";
import UpdateAddress from "../../components/modals/UpdateAddress";
import PurchaseMembership from "../../components/modals/PurchaseMembership";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import loader from "../../components/loader/loader";
import EditCustomerPassword from "../../components/modals/EditCustomerPassword";

const initialState = { alt: "", src: "" };

const EditCustomer = () => {
  const [activeLoader, setActiveLoader] = useState(false);
  const [{ alt, src }, setPreview] = useState(initialState);
  const [img, setImg] = useState();
  const [loading, setLoading] = React.useState(true);
  const [vdata, setVdata] = React.useState(true);
  const [adata, setAdata] = React.useState(true);

  const [Id, setId] = React.useState(true);
  const [AddId, setAddId] = React.useState(true);
  const [AddData, setAddData] = React.useState(true);

  const [checkLoad, setCheckLoad] = React.useState(false);

  const token = localStorage.getItem("token");

  const fileHandler = (event) => {
    const { files } = event.target;
    // Upload Image
    var formdata = new FormData();
    formdata.append("image", event.target.files[0]);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/image`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "success") {
          setActiveLoader(false);
          setImg(result.data.images.image);
          setPreview({ src: APIURL + "/" + result.data.images.image })
        }
      })
      .catch((error) => console.log("error", error));
    setCheckLoad(false);
    setActiveLoader(true);
  };
  const [customerDetails, setCustomerDetails] = useState();
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true)
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .get(`${APIURL}/api/v1/users/${id}`, config)
      .then((response) => {
        console.log('response', response?.data?.data?.user);
        if (response?.data?.data?.user?.image) {
          setPreview({ src: APIURL + "/" + response.data.data.user.image })
        }
        setCustomerDetails(response.data);
        setLoading(false)
      })
      .catch((error) => {
        console.log(error);
      });

  }, [id, checkLoad]);

  const truncate = (input) => {
    if (input?.length > 10) {
      return input?.substring(0, 8) + "...";
    }
    return input;
  };

  const truncateLat = (input) => {
    if (input?.toString()?.length > 4) {
      return input?.toString()?.substring(0, 6) + "...";
    }
    return input;
  };

  const customers = customerDetails?.data?.user
    ? customerDetails?.data?.user
    : "";
  const addressList = customers?.address;
  const vehicleList = customers?.vehicle;
  const parchageList = customers?.purched_memberships;
  const purchasedMembersjip = customers
    ? customers?.purched_memberships?.filter((m) => m.expired == "false")[0]
    : "";

  // 
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [phoneMsg, setPhoneMsg] = useState('')
  const [altPhoneNumber, setAltPhoneNumber] = useState(null)

  useEffect(() => {
    setPhoneNumber(customers?.phone)
    setAltPhoneNumber(customers?.alternative_phone)
  }, [customers?.phone, customers?.alternative_phone])
  const submitedValue = (values) => {
    const payload = {
      ...values,
      phone: phoneNumber,
      alternative_phone: altPhoneNumber
    }
    if (phoneNumber === null || phoneNumber === '') {
      setPhoneMsg('Phone number is required')
      return
    }

    if (phoneNumber !== null) {
      setPhoneMsg('')
      dispatch(updateCustomers(payload, id));
    }

  }

  const cancleRecurringHandle = () => {
    const payload = {
      userId: customers?.id,
    };
    cancelRecurring(payload, (res) => {
      if (res === "success") {
        toast.success("Membership canceled successfully!");
        // The backend now updates subscriptionCanceled/purched_memberships
        // itself as part of the cancel call, so just re-fetch this customer
        // instead of waiting on the Stripe webhook to reflect it.
        setCheckLoad((prev) => !prev);
      }
    });
  };


  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Edit Customer" page="editCustomer">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            {!loading && customers?.id ? (
              <div className="row">
                <div className="col-xl-8">
                  <div className="card card-flush h-lg-100">
                    <div className="card-header pt-7 ">
                      <div className="card-title">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <div className="d-flex justify-content-between w-100 align-items-center">
                          <h2>Edit Customer</h2>
                          <PurchaseMembership
                            modalId={"purchaseMem"}
                            userID={id}
                            emailID={customers?.email}
                            name={
                              customers?.firstName + " " + customers?.lastName
                            }
                          />
                          <button
                            type="submit"
                            className="btn btn-primary py-1 px-3 mx-5"
                            data-bs-toggle="modal"
                            data-bs-target="#purchaseMem"
                          >
                            <span className="indicator-label">
                              Purchase Membership
                            </span>
                          </button>
                          <EditCustomerPassword editDetails={customers} modalId={'custPassModal'} />
                          <button
                            type="submit"
                            className="btn btn-primary py-1 px-3 mx-5"
                            data-bs-toggle="modal"
                            data-bs-target="#custPassModal"
                          >
                            <span className="indicator-label">
                              Change password
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body p-5">
                      <Formik
                        initialValues={{
                          firstName: customers?.firstName,
                          middleName: customers?.middleName,
                          lastName: customers?.lastName,
                          phone: customers?.phone,
                          alternative_phone: customers?.alternative_phone,
                          cell: customers?.cell,
                          home: customers?.home,
                          email: customers?.email,
                          password: customers?.user_id,
                          city: customers?.city,
                          customerNotes: customers?.customerNotes,
                        }}
                        enableReinitialize={true}
                        onSubmit={(values) => {
                          if (img !== "undefined") {
                            values.image = img;
                          } else {
                            values.image = customers?.image;
                          }
                          submitedValue(values)
                        }}
                      >
                        {({ values, handleBlur, handleChange, handleSubmit }) => (
                          <form className="form">
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Profile picture
                                </div>
                              </div>
                              <div className="col-lg-8">
                                <div
                                  className="image-input w-125px h-125px image-input-outline"
                                  style={{
                                    backgroundImage: `url(${src || NoImage})`,
                                  }}
                                >
                                  <label
                                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                    data-kt-image-input-action="change"
                                    data-bs-toggle="tooltip"
                                    title="Change avatar"
                                    data-bs-original-title="Change avatar"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                    </svg>
                                    <input
                                      id="file-input"
                                      accept="image/*"
                                      type="file"
                                      onChange={fileHandler}
                                    />
                                    <input type="hidden" name="avatar_remove" />
                                  </label>
                                  <span
                                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                    data-kt-image-input-action="cancel"
                                    data-bs-toggle="tooltip"
                                    title="Cancel avatar"
                                    data-bs-original-title="Cancel avatar"
                                  >
                                    <i className="bi bi-x fs-2"></i>
                                  </span>
                                  {activeLoader == true ? (
                                    <div
                                      className="d-flex align-items-center justify-content-center h-100"
                                      style={{ background: "#e2e2e270" }}
                                    >
                                      <div
                                        className="spinner-border w-80"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="form-text">
                                  Allowed file types: png, jpg, jpeg.
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    First Name
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="firstName"
                                    id="firstName"
                                    defaultValue={
                                      customers?.firstName
                                        ? customers?.firstName
                                        : values.firstName
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Middle Name
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="middleName"
                                    id="middleName"
                                    defaultValue={
                                      customers?.middleName
                                        ? customers?.middleName
                                        : values.middleName
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Last Name
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="lastName"
                                    id="lastName"
                                    defaultValue={
                                      customers?.lastName
                                        ? customers?.lastName
                                        : values.lastName
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="separator mb-6"></div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    <span className="required">Phone Number</span>
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  {/* <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="phone"
                                  id="phone"
                                  defaultValue={
                                    customers?.phone
                                      ? customers?.phone
                                      : values.phone
                                  }
                                /> */}
                                  <PhoneInput
                                    inputProps={{
                                      name: 'phone'
                                    }}
                                    inputStyle={{
                                      width: '100%',
                                      height: '42px',
                                      background: '#f8f6f2',
                                      border: 'none',
                                      borderRadius: '0.95rem'
                                    }}
                                    value={
                                      customers?.phone
                                        ? customers?.phone
                                        : values.phone
                                    }
                                    country={'bs'}
                                    onChange={(e) => setPhoneNumber(e)}
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Alternative Phone Number
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  {/* <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="alternative_phone"
                                  id="alternative_phone"
                                  defaultValue={
                                    customers?.alternative_phone
                                      ? customers?.alternative_phone
                                      : values.alternative_phone
                                  }
                                /> */}
                                  <PhoneInput
                                    inputProps={{
                                      name: 'alternative_phone'
                                    }}
                                    inputStyle={{
                                      width: '100%',
                                      height: '42px',
                                      background: '#f8f6f2',
                                      border: 'none',
                                      borderRadius: '0.95rem'
                                    }}
                                    value={
                                      customers?.alternative_phone
                                        ? customers?.alternative_phone
                                        : values.alternative_phone
                                    }
                                    country={'bs'}
                                    onChange={(e) => setAltPhoneNumber(e)}
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Home
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="home"
                                    id="home"
                                    defaultValue={
                                      customers?.home
                                        ? customers?.home
                                        : values.home
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Cell
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="cell"
                                    id="cell"
                                    defaultValue={
                                      customers?.cell
                                        ? customers?.cell
                                        : values.cell
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              <div className="separator mb-6"></div>
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Email Address
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={true}
                                    name="email"
                                    id="email"
                                    defaultValue={
                                      customers?.email
                                        ? customers?.email
                                        : values.email
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              {/* <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Password
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="password"
                                  id="password"
                                  defaultValue={
                                    customers?.user_id
                                      ? customers?.user_id
                                      : values.password
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div> */}
                              <div className="row mb-8">
                                <div className="col-xl-3">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Customer Notes
                                  </div>
                                </div>
                                <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="customerNotes"
                                    id="customerNotes"
                                    defaultValue={
                                      customers?.customerNotes
                                        ? customers?.customerNotes
                                        : values.customerNotes
                                    }
                                  />
                                  <div className="fv-plugins-message-container invalid-feedback"></div>
                                </div>
                              </div>
                              {/* <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Status
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <select
                                  className="form-select form-control form-control-solid"
                                  aria-label="Select example"
                                  name="status"
                                  id="status"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  defaultValue={
                                    customers?.status
                                      ? customers?.status
                                      : values.status
                                  }
                                >
                                  <option
                                    value="active"
                                    label="Active"
                                    selected={
                                      customers.status === "active"
                                        ? true
                                        : false
                                    }
                                  >
                                    Active
                                  </option>
                                  <option
                                    value="inactive"
                                    label="Inactive"
                                    selected={
                                      customers.status === "inactive"
                                        ? true
                                        : false
                                    }
                                  >
                                    Inactive
                                  </option>
                                </select>
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div> */}
                            </div>
                            <div className="separator mb-6"></div>
                            <div className="d-flex justify-content-end">
                              <Link
                                to="/manage-customers"
                                type="reset"
                                className="btn btn-light me-3"
                              >
                                Cancel
                              </Link>
                              <button
                                onClick={handleSubmit}
                                type="submit"
                                className="btn btn-primary"
                              >
                                <span className="indicator-label">Save</span>
                              </button>
                            </div>
                            <div></div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4  vehicle-list">
                  <div className="card card-flush h-lg-40 mb-3">
                    <div className="card-header pt-7">
                      <div className="card-title w-100">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <div className="d-flex justify-content-between w-100 align-items-center">
                          <h2>Vehicle List</h2>
                          <AddVehicle modalId={"addVehicle"} userID={id} />
                          <button
                            type="submit"
                            className="btn btn-primary py-1 px-3"
                            data-bs-toggle="modal"
                            data-bs-target="#addVehicle"
                          >
                            <span className="indicator-label">Add New</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body p-5">
                      <table className="table table-striped table-row-bordered ">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Type</th>
                            <th scope="col">Name</th>
                            <th scope="col">Color</th>
                            <th scope="col">Model</th>
                          </tr>
                        </thead>
                        <tbody>
                          <UpdateVehicle
                            modalId={"editveh"}
                            vehicle={vdata}
                            userID={id}
                            vehId={Id}
                          />
                          {vehicleList?.length ? (
                            vehicleList?.map((item, index) => {
                              return (
                                <tr>
                                  <th scope="row">{index + 1}</th>
                                  <td>{truncate(item.type)}</td>
                                  <td>{truncate(item.name)}</td>
                                  <td>{truncateLat(item.color)}</td>
                                  <td>{truncateLat(item.model)}</td>
                                  <td>
                                    <a
                                      to="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#editveh"
                                      className="cursor-pointer"
                                      onClick={() => {
                                        setVdata(item);
                                        setId(item._id);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                      </svg>
                                    </a>
                                    <a
                                      to="#"
                                      className="cursor-pointer"
                                      onClick={() => {
                                        dispatch(VehicleDelete(id, item._id));
                                        setCheckLoad(true);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                      </svg>
                                    </a>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <p className="p-4">No data found</p>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card card-flush h-lg-40">
                    <div className="card-header pt-7">
                      <div className="card-title w-100">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <div className="d-flex justify-content-between w-100 align-items-center">
                          <h2>Address List</h2>
                          <AddAddress modalId={"addAddress"} userID={id} />
                          <button
                            type="submit"
                            className="btn btn-primary py-1 px-3"
                            data-bs-toggle="modal"
                            data-bs-target="#addAddress"
                          >
                            <span className="indicator-label">Add New</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body p-5">
                      <table className="table table-striped table-row-bordered ">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Address</th>
                            <th scope="col">Lat</th>
                            <th scope="col">Lng</th>
                          </tr>
                        </thead>
                        <tbody>
                          <UpdateAddress
                            modalId={"updateAdd"}
                            address={adata}
                            userID={id}
                            addId={AddId}
                            data={AddData}
                          />
                          {addressList?.length ? (
                            addressList?.map((item, index) => {
                              return (
                                <tr>
                                  <th scope="row">{index + 1}</th>
                                  <td>{truncate(item.address)}</td>
                                  <td>{truncateLat(item.lat)}</td>
                                  <td>{truncateLat(item.long)}</td>
                                  <td>
                                    <a
                                      to="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#updateAdd"
                                      className="cursor-pointer"
                                      onClick={() => {
                                        setAdata(item);
                                        setAddId(item._id);
                                        setAddData(item);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                      </svg>
                                    </a>
                                    <a
                                      to="#"
                                      className="cursor-pointer"
                                      onClick={() => {
                                        dispatch(AddressDelete(id, item._id));
                                        setCheckLoad(true);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                      </svg>
                                    </a>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <p className="p-4">No data found</p>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card card-flush h-lg-40 mt-3">
                    <div className="card-header pt-7">
                      <div className="card-title w-100">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <h2>Membership Details</h2>
                        <img
                          className="membership-badge ms-2"
                          src={
                            purchasedMembersjip?.name == "Roadside Assist"
                              ? bronzeImg
                              : purchasedMembersjip?.name == "Roadside Fleet"
                                ? goldImg
                                : purchasedMembersjip?.name == "Roadside Premier"
                                  ? silverImg
                                  : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="card-body p-5">
                      <div className="row mb-8">
                        <div className="col-xl-4">
                          <div className="fs-6 fw-bold">Name :</div>
                        </div>
                        <div className="col-xl-8 p-0 fw-bold fs-7 text-gray-600">
                          {parchageList?.[0]?.name
                            ? parchageList?.[0]?.name
                            : "N/A"}
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-6">
                          <div className="fs-6 fw-bold">Allowed Orders :</div>
                        </div>
                        <div className="col-xl-6 p-0 fw-bold fs-7 text-gray-600">
                          {parchageList?.[0]?.allowedOrders
                            ? parchageList?.[0]?.allowedOrders
                            : "N/A"}
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-6">
                          <div className="fs-6 fw-bold">Placed Orders :</div>
                        </div>
                        <div className="col-xl-6 p-0 fw-bold fs-7 text-gray-600">
                          {parchageList ? parchageList?.[0]?.placedOrders : "N/A"}
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-6">
                          <div className="fs-6 fw-bold">Total Amount :</div>
                        </div>
                        <div className="col-xl-6 p-0 fw-bold fs-7 text-gray-600">
                          {typeof parchageList?.[0]?.transition?.[0]?.amount === "number"
                            ? `$${parchageList[0].transition[0].amount / 100}`
                            : typeof parchageList?.[0]?.transition?.[0]?.amount_received === "number"
                              ? `$${parchageList[0].transition[0].amount_received / 100}`
                              : "N/A"}
                        </div>
                      </div>
                    </div>
                    {customers?.purched_memberships && customers.purched_memberships.length > 0
                      &&
                      <div className="d-flex justify-content-center mb-4">
                        <button
                          className="btn btn-primary"
                          disabled={
                            !customers?.subscriptionCanceled ? false : true
                          }
                          onClick={() => {
                            if (
                              window.confirm(
                                "Do you want to cancel recurring for this user?"
                              )
                            ) { cancleRecurringHandle() }
                          }}
                        >
                          Cancel Membership
                        </button>
                      </div>}
                  </div>
                </div>
              </div>
            ) : loader()}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default connect(null, { updateCustomers })(EditCustomer);
